import { Trans } from "@lingui/react/macro";
import { Card, CardContent, Badge, Text } from "@wootingkb/component-library";

interface Props {
  nameOnWebsite: string;
}

export default function HE80NameOnWebsite({ nameOnWebsite }: Props) {
  return (
    <Card>
      <CardContent className="gap-3">
        <Badge className="w-fit">
          <Trans id="User_he80_founders_campaign_badge">
            80HE Founders Campaign
          </Trans>
        </Badge>

        <Text size="sm">
          <Trans id="User_he80_name_on_website_message">
            Thank you for being part of our Founders campaign! Your name{" "}
            <b>{nameOnWebsite}</b> is forever part of 80HE history.
          </Trans>
        </Text>
      </CardContent>
    </Card>
  );
}
